<div class="tidy-datepicker-field" (click)="toggleMatPicker()">
  @if (label) {
    <tidy-text
      [fieldLabel]="label"
      class="field-label"
      [class.error]="!form?.valid && submitted" />
  }

  <div
    class="input-container"
    [class.invalid-field]="!form?.valid && submitted"
    [class.focused]="calendarOpened">

    @if (icon) {
      <tidy-image [src]="icon" class="input-icon no-right-margin" />
    }

    <input
      [matDatepicker]="picker"
      (dateChange)="changeDate($event)"
      [value]="value"
      [min]="minDate"
      [placeholder]="helperText || placeholder || '' | translate"
      readonly />

    <div class="datepicker-arrow">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M5 4.5L8 2L11 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M5 11.5L8 14L11 11.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>

    <mat-datepicker
      #picker
      [opened]="calendarOpened"
      (closed)="calendarClosed()" />
  </div>

  @if (!form?.valid && submitted) {
    <tidy-error-message [text]="errorMessage" />
  }
</div>
